import { ThemeType } from '@lessonPlanner/constants';

import { PptContent } from '../PptContent';

import { DEFAULT_LAYOUT_STYLES } from '../../../constants/pptThemeLayouts';
import { LayoutStyles } from '../../../types/ppt-slide';

import { BaseLayoutProps } from './BaseLayout';

interface TextLayoutProps extends BaseLayoutProps {
  textFocus: LayoutStyles.DEFAULT | LayoutStyles.CENTERED_FOCUS;
  themeType: ThemeType;
}

const TextContent = ({
  content,
  fontFamily,
  textColor,
  formatContentForPptContent,
}: Omit<BaseLayoutProps, 'themeType'>) => {
  return (
    <PptContent
      content={formatContentForPptContent(content)}
      fontFamily={fontFamily}
      textColor={textColor}
    />
  );
};

export function TextLayout({
  content,
  fontFamily,
  textColor,
  formatContentForPptContent,
  textFocus,
}: TextLayoutProps) {
  // Get layout config directly from DEFAULT_LAYOUT_STYLES
  const layoutConfig =
    textFocus === LayoutStyles.CENTERED_FOCUS
      ? DEFAULT_LAYOUT_STYLES[LayoutStyles.CENTERED_FOCUS]
      : DEFAULT_LAYOUT_STYLES[LayoutStyles.DEFAULT];

  const contentProps = {
    content,
    fontFamily,
    textColor,
    formatContentForPptContent,
  };

  return (
    <div className={layoutConfig.container}>
      <div className={layoutConfig.wrapper}>
        <TextContent {...contentProps} />
      </div>
    </div>
  );
}
